import ButtonGroup from '@visa/vds/button-group';
import ButtonText from '@visa/vds/button-text';
import Col from '@visa/vds/col';
import Grid from '@visa/vds/grid';
import Row from '@visa/vds/row';
import { PRODUCT_SELECTION_STAGE, REVIEW_STAGE } from '_constants/GlobalConstants';
import { DateHelper } from '_helpers/DateHelper';
import MCSOverlayLoading from 'components/MCSOverlayLoading';
import MCSSpace from 'components/MCSSpace';
import React, { act, useEffect, useState } from 'react';
import { SubscriptionApi } from 'services/subscription.service';
import FeeWaiverComponent from './Components/FeeWaiver/FeeWaiverComponent';
import { filterVSTTFeeWaiverOptions } from './Components/FeeWaiver/FeeWaiverLogic';
import VSTSSubscriptionDetails from './Components/SelectDetails/VSTSSubscriptionDetails';
import VSTTSubscriptionDetails from './Components/SelectDetails/VSTTSubscriptionDetails';
import { ProductSelectionConst } from './Components/SelectProduct/ProductSelectionLogic';
import { useAuthContextUser } from 'context/AuthContext';
import { trackPromise } from 'react-promise-tracker';

const SelectDetails = (props) => {
    let {
        selectedCategory,
        // VSTS
        selectedVSTSSubscriptionInfoId,
        selectedVSTSStartDate, setSelectedVSTSStartDate,
        selectedVSTSEndDate, setSelectedVSTSEndDate,

        // VSTT
        selectedVSTTProducts, setSelectedVSTTProducts,
        selectedVSTTProductInfoDetails, setVSTTSelectedProductInfoDetails,
        setSelectedVSTTSubscriptions,
        setTotalVSTTSetupFee,
        setTotalVSTTMonthlyFee,
        setTotalVSTTYearlyFee,

        // Fee Waiver
        selectedFeeWaiverId, setSelectedFeeWaiverId,
        feeWaiverOptions, setFeeWaiverOptions,

        handleStepUpdate,
    } = props;

    const [currentVstsSubscriptionEndDate, setCurrentVstsSubscriptionEndDate] = useState(null);
    const ERROR_TEXT_VSTS_START_DATE_REQUIRED = "Please select a Start Date before proceeding."
    const [errorText, setErrorText] = useState(null);
    const [showVSTSStartDateError, setShowVSTSStartDateError] = useState(false);
    const [isLoadingFeeWaiver, setIsLoadingFeeWaiver] = useState(true);

    /** FOR VSTT ONLY START */
    const [subscriptionSelectedMapping, setSubscriptionSelectedMapping] = useState([]);
    //const [subscriptionSelectedMappingStartDate, setSubscriptionSelectedMappingStartDate] = useState([]);

    const [subscriptionSelectErrorList, setSubscriptionSelectErrorList] = useState([]);
    //const [subscriptionSelectStartDateErrorList, setSubscriptionSelectStartDateErrorList] = useState([]);
    /** FOR VSTT ONLY END */

    /** FOR Fee Waiver or Fee Discount START */
    const [filteredFeeWaiverOptions, setFilteredFeeWaiverOptions] = useState([]);
    /** FOR Fee Waiver or Fee Discount END */

    const RetrieveProductInfoDetails = (productId, subscriptionId) => {
        var product = selectedVSTTProductInfoDetails.find(x => x.productId == productId);

        if (product !== undefined) {
            var productPriceMapping = product.productPriceMappings;
            var retrievedProductSubscription = productPriceMapping.find(x => x.id == subscriptionId);
            var retrievedProductSetup = productPriceMapping.find(x => x.productInfoId == ProductSelectionConst.VSTT_SETUP)
            if (retrievedProductSetup != undefined) {
                retrievedProductSubscription.hasSetUp = true;
                retrievedProductSubscription.setUpSubscription = retrievedProductSetup;
            }
            return retrievedProductSubscription
        }

        return null;
    }

    const PushToConfirmedProductList = (subscriptionSelected, confirmedList) => {
        var currentProductSubscription = RetrieveProductInfoDetails(subscriptionSelected.productId, subscriptionSelected.subscriptionId)
        if (currentProductSubscription != undefined) {
            currentProductSubscription.startDate = DateHelper.ToUTCDateTime(new Date());
            confirmedList.push(currentProductSubscription);
        }
    }

    const SumVSTTFees = (confirmedProductList) => {
        var totalSetupFee = 0;
        var totalMonthlyFee = 0;
        var totalYearlyFee = 0;

        console.log('confirmedProductList: ', confirmedProductList); // to check if we can calculate TotalVSTTSetupFee in here
        confirmedProductList.forEach((product) => {
            // Setup fees
            if (product.hasSetUp && product.setUpSubscription) {
                totalSetupFee += product.setUpSubscription.fee;
            }

            // Recurring fees
            if (product.recurringIntervalType === ProductSelectionConst.MONTHLY_SUBSCRIPTION_INTERVAL) {
                totalMonthlyFee += product.fee;
            } else if (product.recurringIntervalType === ProductSelectionConst.YEARLY_SUBSCRIPTION_INTERVAL) {
                totalYearlyFee += product.fee
            }
        })

        setTotalVSTTSetupFee(totalSetupFee);
        setTotalVSTTMonthlyFee(totalMonthlyFee);
        setTotalVSTTYearlyFee(totalYearlyFee);
    }

    const ResetSelectedProducts = () => {
        if (selectedCategory === ProductSelectionConst.VSTT_CATEGORY) {
            setSelectedVSTTProducts([]);
            setVSTTSelectedProductInfoDetails([]);
        }
        handleStepUpdate(PRODUCT_SELECTION_STAGE);
    }

    const ValidateDetailsAndProceed = () => {
        if (showVSTSStartDateError) return
        if (selectedCategory === ProductSelectionConst.VSTS_CATEGORY && selectedVSTSStartDate == null) {
            setErrorText(ERROR_TEXT_VSTS_START_DATE_REQUIRED)
            setShowVSTSStartDateError(true);
            return;
        }

        if (selectedCategory === ProductSelectionConst.VSTT_CATEGORY) {
            var currentSubscriptionSelectedErrorList = []
            var confirmedProductList = []

            selectedVSTTProducts.forEach((productId) => {
                var subscriptionSelected = subscriptionSelectedMapping.find(x => x.productId === productId);
                //var startDateSelected = subscriptionSelectedMappingStartDate.find(x => x.productId == productId);
                if (subscriptionSelected === undefined) {
                    currentSubscriptionSelectedErrorList.push(productId);
                }
                else {
                    PushToConfirmedProductList(subscriptionSelected, confirmedProductList)
                }
            })

            SumVSTTFees(confirmedProductList);
            setSubscriptionSelectErrorList(currentSubscriptionSelectedErrorList);
            setSelectedVSTTSubscriptions(confirmedProductList);

            if (currentSubscriptionSelectedErrorList.length != 0) {
                return;
            }
        }

        handleStepUpdate(REVIEW_STAGE);
    }

    useEffect(() => {
        // to fetchVSTTProductSubscriptions
        fecthVSTTProducSubscriptions(selectedVSTTProducts);
    }, [selectedVSTTProducts]);

    const fecthVSTTProducSubscriptions = async (productIds) => {
        if (selectedVSTTProducts.length !== 0) {
            const productSubscriptions = await SubscriptionApi.GetSelectedProductSubscriptions(productIds);
            setVSTTSelectedProductInfoDetails(productSubscriptions);
        }
    }

    useEffect(() => {
        checkVSTSActiveSubscription()
    }, [selectedVSTSSubscriptionInfoId])

    const checkVSTSActiveSubscription = async () => {
        if (selectedVSTSSubscriptionInfoId == 2) {
            trackPromise(SubscriptionApi.GetCurrentActiveSubscription()
                .then((res) => {
                    if (typeof res == 'object' && res.currentSubscription != null) {
                        let date = new Date(res.currentSubscription.endDate)
                        date.setDate(date.getDate())
                        setCurrentVstsSubscriptionEndDate(date);
                    }
                })
                .catch(error => { }))
        }
    }

    /** Fee Waiver or Fee Discount Logic START */
    // logic to populate Fee Waiver or Fee Discount options.
    useEffect(() => {
        // to fetchFeeWaiverOptions
        const productSubscriptionIds = retrieveProductSubscriptionIds();
        fetchFeeWaiverOptions(productSubscriptionIds);
    }, [selectedCategory, selectedVSTSSubscriptionInfoId, selectedVSTTProductInfoDetails]);

    // get productSubscriptionIds of previously selected products.
    const retrieveProductSubscriptionIds = () => {
        const productSubscriptionIds = [];
        if (selectedCategory === ProductSelectionConst.VSTS_CATEGORY) {
            productSubscriptionIds.push(selectedVSTSSubscriptionInfoId);
        } else if (selectedCategory === ProductSelectionConst.VSTT_CATEGORY) {
            selectedVSTTProductInfoDetails.forEach((product) => {
                product.productPriceMappings.forEach((productSubscription) => {
                    productSubscriptionIds.push(productSubscription.id);
                })
            });
        }

        return productSubscriptionIds;
    }

    // use productSubscriptionIds to fetch full names of options from database.
    const fetchFeeWaiverOptions = async (productSubscriptionIds) => {
        if (productSubscriptionIds.length == 0) return

        const res = await SubscriptionApi.GetFeeWaiverOptions(productSubscriptionIds);
        setFeeWaiverOptions(res);
        setIsLoadingFeeWaiver(false);
    };

    useEffect(() => {
        // to setFilteredFeeWaiverOptions
        // maintain a set of selected subscriptions. set is used to compare with each Fee Waiver or Fee Discount option, to decide if it needs to be displayed.
        // once for VSTS
        // multiple times for VSTT depending on selection on subscriptionSelectedMapping

        // reset Fee Waiver or Fee Discount selection
        setSelectedFeeWaiverId(-1);

        // if no Fee Waiver or Fee Discount options available
        if (!feeWaiverOptions) return;

        // no need to filter options for VSTS.
        if (selectedCategory === ProductSelectionConst.VSTS_CATEGORY) {
            setFilteredFeeWaiverOptions(feeWaiverOptions);
            return;
        }

        if (subscriptionSelectedMapping == null) return;
        const selectedSubscriptionSet = new Set();

        subscriptionSelectedMapping.forEach((item) => {
            selectedSubscriptionSet.add(item.subscriptionId);
        })

        const updatedFilteredFeeWaiverOptions = filterVSTTFeeWaiverOptions(selectedSubscriptionSet, feeWaiverOptions);
        setFilteredFeeWaiverOptions(updatedFilteredFeeWaiverOptions);
    }, [subscriptionSelectedMapping, feeWaiverOptions]);
    /** Fee Waiver or Fee Discount Logic END */

    const pageIsLoading = () => {
        return (selectedCategory === ProductSelectionConst.VSTT_CATEGORY && selectedVSTTProductInfoDetails.length === 0) || isLoadingFeeWaiver;
    }

    if (pageIsLoading()) {
        return (
            <MCSOverlayLoading />
        )
    }
    //&& ...props.
    const btnDisabled = () => {
        return (filteredFeeWaiverOptions.length > 0 && selectedFeeWaiverId === -1)
    }

    return (
        <>
            <MCSSpace height="30px" />
            <Grid>
                <Row>
                    <Col>
                        {selectedCategory && selectedCategory === ProductSelectionConst.VSTS_CATEGORY &&
                            <VSTSSubscriptionDetails
                                selectedProductInfo={selectedVSTSSubscriptionInfoId}
                                selectedVSTSStartDate={selectedVSTSStartDate}
                                setSelectedVSTSStartDate={setSelectedVSTSStartDate}
                                selectedVSTSEndDate={selectedVSTSEndDate}
                                setSelectedVSTSEndDate={setSelectedVSTSEndDate}
                                showVSTSStartDateError={showVSTSStartDateError}
                                setShowVSTSStartDateError={setShowVSTSStartDateError}
                                currentVstsSubscriptionEndDate={currentVstsSubscriptionEndDate}
                                errorText={errorText}
                                setErrorText={setErrorText}
                            />
                        }
                        {selectedCategory && selectedCategory === ProductSelectionConst.VSTT_CATEGORY &&
                            <VSTTSubscriptionDetails selectedProductInfoDetails={selectedVSTTProductInfoDetails}
                                subscriptionSelectedMapping={subscriptionSelectedMapping} setSubscriptionSelectedMapping={setSubscriptionSelectedMapping}
                                subscriptionSelectErrorList={subscriptionSelectErrorList}
                            />
                        }
                    </Col>
                    <Col>
                        <FeeWaiverComponent
                            selectedCategory={selectedCategory}
                            selectedVSTTProductInfoDetails={selectedVSTTProductInfoDetails}
                            subscriptionSelectedMapping={subscriptionSelectedMapping}
                            filteredFeeWaiverOptions={filteredFeeWaiverOptions}
                            selectedFeeWaiverId={selectedFeeWaiverId}
                            setSelectedFeeWaiverId={setSelectedFeeWaiverId}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ButtonGroup direction="right">
                            <ButtonText colorScheme="secondary" onClick={() => ResetSelectedProducts()}>Back</ButtonText>
                            <ButtonText disabled={btnDisabled()} onClick={() => ValidateDetailsAndProceed()}>Next</ButtonText>
                        </ButtonGroup>
                    </Col>
                </Row>
            </Grid>
        </>);
}

export default SelectDetails